export enum PreferencesProperties {
  MediaFormatQuality = 'mediaFormatQuality',
  Language = 'language',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
}
export enum PreferencesMetaProperties {}
